export default __webpack_public_path__ + "static/background-img-088f63a02f34e165a4b0d6bba456738b.png";